<template>
  <el-dialog
    title="Создать пользователя"
    :visible="visible"
    custom-class="el-dialog--small"
    :close-on-click-modal="false"
    @update:visible="closeDialog">
    <el-form
      ref="form"
      :model="model"
      :rules="rules"
      @submit.native.prevent="onSubmit">
      <el-form-item label="Ф.И.О" prop="name">
        <el-input v-model="model.name" type="text" />
      </el-form-item>
      <el-form-item label="E-mail" prop="email">
        <el-input v-model="model.email" autocomplete="new-password" type="email" />
      </el-form-item>
      <el-form-item label="Пароль" prop="password">
        <el-input
          v-model="model.password"
          autocomplete="new-password"
          type="password"
          show-password />
      </el-form-item>
      <el-form-item label="Доступ к базам" prop="databases">
        <el-select
          v-model="model.databasesIds"
          value-key="id"
          multiple
          clearable
          class="w-100">
          <el-option
            v-for="database in databases"
            :key="database.id"
            :label="database.name"
            :value="database.id" />
        </el-select>
      </el-form-item>
      <el-form-item prop="isAdmin">
        <el-checkbox v-model="model.isAdmin">
          Администратор
        </el-checkbox>
      </el-form-item>
      <el-form-item prop="hasAccountAccess">
        <el-checkbox
          v-model="model.hasAccountAccess"
          :disabled="model.isAdmin">
          Доступ в ЛК
        </el-checkbox>
      </el-form-item>
      <div class="text-xs text-muted mt-8">Стоимость создания пользователя: {{ accData.userCost }} рублей</div>
      <div class="divider" />
      <div class="flex-x-center">
        <el-button
          type="primary"
          size="medium"
          native-type="submit"
          :loading="$mip('createUser')">
          Создать
        </el-button>
        <el-button
          type="primary"
          size="medium"
          plain
          @click="closeDialog">
          Отменить
        </el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import { clearFormData } from '@/utils'
  import { mapGetters, mapState } from 'vuex'

  export default {
    props: {
      visible: Boolean,
      userId: String
    },

    data() {
      return {
        rules: {
          name: [
            { required: true, message: 'Пожалуйста, введите Ф.И.О', trigger: 'blur' }
          ],
          email: [
            { type: 'email', message: 'Пожалуйста, введите правильный email', trigger: ['blur', 'change'] }
          ],
          password: [
            { required: true, message: 'Пожалуйста, введите пароль', trigger: 'blur' },
            { min: 5, message: 'Пароль должен содержать минимум 5 символов' }
          ]
        },
        model: {
          name: '',
          email: '',
          password: '',
          databasesIds: [],
          isAdmin: false
        }
      }
    },

    computed: {
      ...mapState({
        databases: state => state.databases.databases,
        accData: state => state.user.accInfo
      }),

      ...mapGetters([ 'getUserById', 'getDatabaseById' ])
    },

    methods: {
      onSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.createUser()
          } else {
            console.error('Error: form validation')
            return false
          }
        })
      },

      createUser() {
        this.$store.dispatch('createUser', this.model).then(() => {
          this.closeDialog()
          this.$notify({
            title: 'Создание пользователя',
            message: 'Ваша заявка принята. С вами свяжется менеджер',
            type: 'success'
          })
        })
      },

      closeDialog() {
        this.$emit('update:visible', false)
        this.model = clearFormData(this.model, { isAdmin: false })
      }
    }
  }
</script>